export const treeState = {
    NotFound: 'not found',
}

export const locationModalTypes = {
    Add: "Add",
    Edit: "Edit"
}

export const treeTypes = {
    Mini: "Mini",
    FullSize: "FullSize"
}